import { Cpu, Smartphone, Tv, KeyRound, Network, Wrench, ShieldCheck, HardDrive, Wifi, Server, Database, Monitor, Headphones, Camera, Gamepad2, Radio } from 'lucide-react';

export const services = [
  {
    icon: Cpu,
    title: 'Assistenza Tecnica',
    description: "Riparazioni in garanzia e fuori garanzia su PC, notebook e dispositivi multimarca con preventivi trasparenti.",
  },
  {
    icon: Smartphone,
    title: 'Riparazione Smartphone',
    description: 'Sostituzione schermi, batterie e schede madre per iPhone, Samsung, Xiaomi e tutti i principali brand.',
  },
  {
    icon: Tv,
    title: 'Riparazione TV & Audio',
    description: 'Smart TV, OLED, QLED, soundbar, home theatre, autoradio e impianti HiFi rimessi a nuovo.',
  },
  {
    icon: KeyRound,
    title: 'Duplicazione Telecomandi',
    description: 'Cloniamo telecomandi per cancelli e garage. Vendita telecomandi universali per ogni TV.',
  },
  {
    icon: Network,
    title: 'Reti & Sistemi Aziendali',
    description: 'Progettazione reti LAN/Wi-Fi, firewall, VPN e virtualizzazione server per aziende e professionisti.',
  },
  {
    icon: HardDrive,
    title: 'Recupero Dati',
    description: 'Salvataggio dati da hard disk, SSD, schede SD, smartphone e console, anche in caso di guasto critico.',
  },
];

export const features = [
  { icon: Wrench, label: 'Ritiro & consegna a domicilio' },
  { icon: ShieldCheck, label: '3 mesi di garanzia sulla riparazione' },
  { icon: Wifi, label: 'Assistenza remota immediata' },
  { icon: Server, label: 'Backup e sicurezza dati' },
  { icon: Database, label: 'Migrazione e configurazione cloud' },
  { icon: Monitor, label: 'Installazione sistemi operativi' },
];

export const repairCategories = [
  { icon: Monitor, title: 'PC & Notebook', items: ['Sostituzione SSD/RAM', 'Pulizia interna e termica', 'Riparazione scheda madre', 'Recupero password'] },
  { icon: Smartphone, title: 'Smartphone & Tablet', items: ['Schermi LCD/OLED', 'Batterie originali', 'Connettori di carica', 'Sblocco e flashing'] },
  { icon: Tv, title: 'TV & Home Theatre', items: ['Pannelli LED/OLED', 'Schede T-CON', 'Alimentatori', 'Aggiornamenti firmware'] },
  { icon: Headphones, title: 'Audio & Car Audio', items: ['Cuffie wireless', 'Soundbar', 'Autoradio', 'Amplificatori HiFi'] },
  { icon: Camera, title: 'Foto & Video', items: ['Fotocamere reflex', 'Action cam', 'Videocamere', 'Droni'] },
  { icon: Gamepad2, title: 'Console & Gaming', items: ['PlayStation', 'Xbox', 'Nintendo Switch', 'Joypad e accessori'] },
];

export const brands = [
  'Samsung', 'LG', 'Sony', 'Apple', 'Xiaomi', 'Huawei', 'Lenovo', 'HP', 'Dell', 'Asus', 'Acer', 'Microsoft', 'Philips', 'Panasonic', 'JBL', 'Bose', 'Canon', 'Nikon', 'GoPro', 'TP-Link', 'Netgear', 'Ubiquiti', 'Synology', 'Brother',
];

export const warrantyBrands = [
  'Saba', 'United', 'TREVI', 'EMG', 'Trevidea', 'G3 Ferrari', 'Girmi', 'Zephir', 'Qbell', 'Teklio', 'Techlife', 'Pyramidea',
];

export const stats = [
  { value: '29+', label: 'Anni di esperienza' },
  { value: '15.000+', label: 'Riparazioni effettuate' },
  { value: '98%', label: 'Clienti soddisfatti' },
  { value: '48h', label: 'Tempo medio di intervento' },
];

export const testimonials = [
  {
    name: 'Massimo Bellini',
    role: 'Local Guide · 2 mesi fa',
    content: 'Bravo il tecnico a spiegare le problematiche del tuo elettrodomestico, consiglio vivamente.',
    rating: 5,
  },
  {
    name: 'Daniele Cazzaniga',
    role: 'Local Guide · 210 recensioni',
    content: 'Persone preparate, oneste ed affidabili! Sinonimo di garanzia: dopo una prima analisi, ti chiamano e ti spiegano tutto. Da preferire al classico negozio "fai da te".',
    rating: 5,
  },
  {
    name: 'Alberta Stocco',
    role: 'Cliente verificato',
    content: "Affidabili, puntuali, onesti! Riparano anche l'irreparabile e si assumono sempre la responsabilità di accettare solo lavori di cui possano garantire il buon esito. Una certezza!",
    rating: 5,
  },
  {
    name: 'Cesare Mariani',
    role: 'Local Guide · 16 recensioni',
    content: 'Gentile e disponibile, come sempre.',
    rating: 5,
  },
  {
    name: 'Enrico DM',
    role: 'Local Guide · 18 recensioni',
    content: 'Assistenza top. Massima professionalità e cortesia. Consigliatissimi!!!',
    rating: 5,
  },
  {
    name: 'Fabio Mottadelli',
    role: 'Local Guide · 66 recensioni',
    content: 'Bravi, competenti ed onesti... Qualità rara.',
    rating: 5,
  },
  {
    name: 'Richard Doni',
    role: 'Local Guide · 480 recensioni',
    content: 'Ottimi, veloci e professionali. Buona anche l\u2019assistenza post riparazione.',
    rating: 5,
  },
  {
    name: 'Rodolfo Maino',
    role: 'Local Guide · 25 recensioni',
    content: 'Molto efficienti, veloci ma soprattutto onesti con i costi di lavorazione.',
    rating: 5,
  },
  {
    name: 'Paolo Montingelli',
    role: 'Local Guide · 169 recensioni',
    content: 'Riparazione rapida, preventivo affidabile. La TV funziona benissimo e ho evitato la scocciatura di smontare tutti i cablaggi. Grazie!',
    rating: 5,
  },
  {
    name: 'Michele Stien',
    role: 'Local Guide · 42 recensioni',
    content: 'Onesti sin dal primo impatto e tecnicamente molto preparati. Consigliatissimo!',
    rating: 5,
  },
  {
    name: 'Davide Domenico Pacetta',
    role: 'Local Guide · 23 recensioni',
    content: 'Mi sono trovato benissimo per la riparazione di un elettrodomestico. Il personale è gentile e disponibile.',
    rating: 5,
  },
  {
    name: 'Renato Brambi',
    role: 'Cliente verificato',
    content: 'Gentilezza e professionalità. Riparazione nel tempo concordato, stessa mattina.',
    rating: 5,
  },
];

export const navLinks = [
  { label: 'Servizi', href: '#servizi' },
  { label: 'Chi Siamo', href: '#chi-siamo' },
  { label: 'Riparazioni', href: '#riparazioni' },
  { label: 'Marchi', href: '#marchi' },
  { label: 'Contatti', href: '#contatti' },
];

export const contactInfo = {
  address: 'Via Goffredo Mameli, 29 (Ingresso Via Mazzini)',
  city: '20853 Biassono (MB)',
  phone: '039 2322012',
  whatsapp: '366 452 3435',
  whatsappRaw: '393664523435',
  whatsappMessage: 'Ciao GT Assistenza, vorrei informazioni su...',
  emails: [
    { label: 'Informazioni & primo contatto', value: 'info@gtassistenza.it' },
    { label: 'Amministrazione & moduli di reso', value: 'amministrazione@gtassistenza.it' },
    { label: 'Tecnico riparazioni', value: 'tecnico@gtassistenza.it' },
  ],
  hours: [
    { day: 'Lunedì - Venerdì', time: '9:00 - 12:30 / 14:30 - 19:00' },
    { day: 'Sabato', time: '9:00 - 12:30' },
    { day: 'Domenica', time: 'Chiuso' },
  ],
};

export const heroImage = 'https://images.unsplash.com/photo-1768633647910-7e6fb53e5b0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxjb21wdXRlciUyMHJlcGFpciUyMHRlY2huaWNpYW58ZW58MHx8fHwxNzc4MDYyMTkxfDA&ixlib=rb-4.1.0&q=85';
export const aboutImage = 'https://images.pexels.com/photos/12741843/pexels-photo-12741843.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';
export const labImage = 'https://images.pexels.com/photos/36861987/pexels-photo-36861987.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';
export const phoneImage = 'https://images.unsplash.com/photo-1611396000732-f8c9a933424f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxzbWFydHBob25lJTIwcmVwYWlyfGVufDB8fHx8MTc3ODA2MjE5MXww&ixlib=rb-4.1.0&q=85';
